"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomString = exports.processObject = exports.processObjectArray = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const interfaces_1 = require("@buildcore/interfaces");
const lodash_1 = require("lodash");
const processObjectArray = (array) => array.map((obj) => (0, exports.processObject)(obj));
exports.processObjectArray = processObjectArray;
const processObject = (obj) => {
    const entries = Object.entries(obj);
    if (!entries.length) {
        return undefined;
    }
    return entries.reduce((acc, [key, val]) => (Object.assign(Object.assign({}, acc), { [key]: processValue(val) })), {});
};
exports.processObject = processObject;
const processValue = (value) => {
    if (value && Array.isArray(value)) {
        return value.map(processValue);
    }
    if (value && typeof value === 'object') {
        const keys = Object.keys(value);
        if ((0, lodash_1.isEqual)(keys, ['seconds', 'nanoseconds'])) {
            return new interfaces_1.Timestamp(value.seconds, value.nanoseconds);
        }
        return (0, exports.processObject)(value);
    }
    return value;
};
const randomString = (length = 16) => {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0154326789';
    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        result += characters.charAt(randomIndex);
    }
    return result;
};
exports.randomString = randomString;
